import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';
import { AsaasCheckout } from './AsaasCheckout';

const BRL = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const PaymentTabs = ({ editorId, token, amount, payerEmail, color = '#68AAB0', onDone, onPaid, cardOnly, initialTab }) => (
  <AsaasCheckout editorId={editorId} token={token} amount={amount} payerEmail={payerEmail} color={color} onDone={onDone} onPaid={onPaid} cardOnly={cardOnly} initialTab={initialTab} />
);

const Perk = ({ children }) => (
  <li style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: '0.85rem', color: '#4a5568', marginBottom: 6 }}>
    <Check className="w-4 h-4" style={{ color: '#38a169', flexShrink: 0, marginTop: 2 }} /><span>{children}</span>
  </li>
);

export const CheckoutPanel = (props) => (
  <div data-testid="checkout-panel" className="checkout-panel" style={{ display: 'grid', gap: '1.5rem' }}>
    <aside data-testid="checkout-summary" style={{ background: '#f7fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: '1.25rem' }}>

      <p style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.06em', color: '#a0aec0' }}>Sua assinatura</p>
      <p data-testid="checkout-editor-name" style={{ fontWeight: 700, color: '#2D3748', fontSize: '1.05rem' }}>{props.editorName}</p>
      <p data-testid="checkout-amount" style={{ fontSize: '1.75rem', fontWeight: 800, color: '#2D3748', margin: '0.5rem 0 1rem' }}>
        {BRL(props.amount)}<span style={{ fontSize: '0.85rem', fontWeight: 500, color: '#718096' }}>/mês</span>
      </p>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        <Perk>Acesso a todo o acervo digital do catálogo</Perk>
        <Perk><strong>Cartão:</strong> renova sozinho todo mês; cancele quando quiser</Perk>
        <Perk><strong>Pix:</strong> mensal até você cancelar; o Pix de cada mês chega por e-mail 5 dias e 1 dia antes do vencimento</Perk>
      </ul>
      <p style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: '0.75rem', color: '#718096', marginTop: '1rem' }}>
        <ShieldCheck className="w-4 h-4" style={{ color: '#38a169' }} />Pagamento processado com segurança pelo Asaas, sem sair desta página.
      </p>
    </aside>
    <section><PaymentTabs {...props} /></section>
  </div>
);
